function createTag(route) {
  return {
    path: route.path,
    fullPath: route.fullPath,
    name: route.name,
    title: (route.meta && route.meta.title) || route.name || '未命名页面'
  }
}

const state = {
  visitedViews: []
}

const mutations = {
  ADD_VISITED_VIEW(state, route) {
    if (state.visitedViews.some(view => view.path === route.path)) {
      return
    }
    state.visitedViews.push(createTag(route))
  },
  DEL_VISITED_VIEW(state, route) {
    state.visitedViews = state.visitedViews.filter(view => view.path !== route.path)
  },
  CLEAR_VISITED_VIEWS(state) {
    state.visitedViews = []
  }
}

const actions = {
  addView({ commit }, route) {
    commit('ADD_VISITED_VIEW', route)
  },
  delView({ commit }, route) {
    commit('DEL_VISITED_VIEW', route)
  },
  clearViews({ commit }) {
    commit('CLEAR_VISITED_VIEWS')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
